/**
 * NKBA API
 * The RESTful backend behind the NKBA application
 *
 * OpenAPI spec version: V1.0.0
 * Contact: cloud@nkba.org
 *
 * NOTE: This class is auto generated by the swagger code generator program.
 * https://github.com/swagger-api/swagger-codegen.git
 * Do not edit the class manually.
 */

export interface Tag {
    /**
     * name of tag
     */
    name?: string;

    /**
     * globally unique id
     */
    id?: string;

    /**
     * type of tag
     */
    type?: Tag.Type;

    /**
     * description of the tag
     */
    description?: string;

    /**
     * created by user id
     */
    createId?: string;

    /**
     * created timestamp
     */
    createAt?: string;

    /**
     * last updated timestamp
     */
    updateAt?: string;

    /**
     * slug of tag
     */
    slug?: string;

    /**
     * path to primary logo image
     */
    imagePath?: string;

    /**
     * last updated by user id
     */
    updateId?: string;

    /**
     * path to hero image
     */
    heroImagePath?: string;

    /**
     * deleted by user id
     */
    deleteId?: string;

    /**
     * deleted timestamp
     */
    deleteAt?: string;

    /**
     * short name of tag
     */
    shortName?: string;

}

export namespace Tag {

    export enum Type {
            BRAND = <any> 'BRAND',
            STYLE = <any> 'STYLE',
            PRODUCT = <any> 'PRODUCT',
            CATEGORY = <any> 'CATEGORY',
            SERVICE = <any> 'SERVICE',
            CERTIFICATION = <any> 'CERTIFICATION',
            INTERNAL = <any> 'INTERNAL',
            BACKSPLASH_MATERIAL = <any> 'BACKSPLASH_MATERIAL',
            BACKSPLASH_COLOR = <any> 'BACKSPLASH_COLOR',
            BATHTUB = <any> 'BATHTUB',
            BATHROOM_TYPE = <any> 'BATHROOM_TYPE',
            BUDGET = <any> 'BUDGET',
            CABINET_FINISH = <any> 'CABINET_FINISH',
            CABINET_STYLE = <any> 'CABINET_STYLE',
            COLOR = <any> 'COLOR',
            COUNTER_MATERIAL = <any> 'COUNTER_MATERIAL',
            FLOOR_COLOR = <any> 'FLOOR_COLOR',
            FLOOR_MATERIAL = <any> 'FLOOR_MATERIAL',
            ISLANDS = <any> 'ISLANDS',
            KITCHEN_LAYOUT = <any> 'KITCHEN_LAYOUT',
            KITCHEN_TYPE = <any> 'KITCHEN_TYPE',
            SHOWER_ENCLOSURE = <any> 'SHOWER_ENCLOSURE',
            SHOWER_TYPE = <any> 'SHOWER_TYPE',
            SINK = <any> 'SINK',
            SIZE = <any> 'SIZE',
            TOILET = <any> 'TOILET',
            WALL_COLOR = <any> 'WALL_COLOR',
            ROOM = <any> 'ROOM',
            WALL_TILE_COLOR = <any> 'WALL_TILE_COLOR',
            WALL_TILE_MATERIAL = <any> 'WALL_TILE_MATERIAL',
            APPLIANCE_FINISH = <any> 'APPLIANCE_FINISH',
            JOB_TYPE = <any> 'JOB_TYPE',
            JOB_EXPERIENCE = <any> 'JOB_EXPERIENCE',
            BADGE = <any> 'BADGE'
    }
}



// WEBPACK FOOTER //
// ./src/common/api/models/Tag.ts